/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetch_categories_action } from '../_redux/action';

const CategorySearchBasic = ({ defaultValue, onSearchChange }) => {
  const [options, setOptions] = useState([]);
  const dispatch = useDispatch();

  const { categories } = useSelector((state) => state.fetch_categories_reducer);

  const selectedValues = (defaultValue || []).map((category) => category._id || category);

  const ref = useRef();
  // useEffect(() => {
  //   if (ref?.current && ref?.current?.value) {
  //     ref.current.value = defaultValue;
  //   }
  // }, []);

  useEffect(() => {
    const callApi = async () => {
      await dispatch(fetch_categories_action());
    };
    callApi();
  }, []);

  useEffect(() => {
    if (categories) {
      setOptions(categories);
    }
  }, [categories]);

  return (
    <Select
      ref={ref}
      mode="multiple"
      showSearch
      value={selectedValues} // Use an array of IDs instead of objects
      style={{ width: '100%' }}
      placeholder="Search Category"
      allowClear
      options={(options || []).map((d) => ({
        value: d?._id,
        label: d?.title,
      }))}
      getPopupContainer={(trigger) => trigger.parentNode}
      filterOption={(input, option) => option?.label?.toLowerCase().includes(input.toLowerCase())}
      onChange={onSearchChange}
    />
  );
};
export default CategorySearchBasic;
